<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">客服昵称</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <div class="header-id" style="margin-bottom: 20px">
          <div style="margin-bottom: 40px">
            <FilterCommon :model="model" :isAdd="isSuperAdmin" @add="add" @search="search" :isReset="true" @reset="reset">
              <template v-slot:button>
                <el-button type="primary" @click="save">保存</el-button>
                <!-- 超级管理员的导入功能 -->
                <el-button type="primary" v-if="isSuperAdmin" @click="importService">导入</el-button>
                <!-- 超级管理员的导出功能 -->
                <el-button type="primary" v-if="isSuperAdmin" @click="exportService">导出</el-button>
                <!-- 非超级管理员的确认按钮 -->
                <el-button type="primary" v-if="isShowEnSure" @click="sureThisList">确认</el-button>
                <!-- 管理员的切换按钮 -->
                <el-button type="primary" v-if="isShowChange" @click="changeShowPage">切换</el-button>
              </template>
            </FilterCommon>
            <el-table border v-loading="listLoading" :data="tableData" style="width: 100%">
              <el-table-column prop="nickname" label="客服昵称">
                <template slot="header">
                  <span>客服名称</span>
                  <i class="el-icon-document-copy copy-column-icon" title="复制本列" @click.stop="copyColumn('nickname', $event)"></i>
                </template>
              </el-table-column>
              <el-table-column v-for="item in timeArr" :key="item" :prop="item" :label="item">
                <template slot="header">
                  <span>{{ item }}</span>
                  <i class="el-icon-document-copy copy-column-icon" title="复制本列" @click.stop="copyColumn(item, $event)"></i>
                </template>
              </el-table-column>
              <el-table-column :label="currentTime">
                <template slot="header">
                  <span>{{ currentTime }}</span>
                  <i class="el-icon-document-copy copy-column-icon" title="复制本列" @click.stop="copyColumn(currentTime, $event)"></i>
                </template>
                <template slot-scope="scope">
                  <el-input :class="[scope.row.ensure_status === 0 ? 'fontred' : 'fontgreen']" v-model="saveArr[scope.row.nickname]"></el-input>
                </template>
              </el-table-column>
              <el-table-column v-if="delShow" label="操作">
                <template slot-scope="scope">
                  <el-button style="margin-right: 10px" size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
                  <el-popover placement="top" width="160" v-model="scope.row.deleteVisible">
                    <p>确定删除吗?</p>
                    <div style="text-align: right; margin: 0">
                      <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                      <el-button type="primary" size="mini" @click="del(scope.row)">确定</el-button>
                    </div>
                    <el-button slot="reference" size="mini" type="danger">删除</el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>

            <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="'新增昵称'" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>
            <!-- 2022.02.08新增，编辑昵称弹窗 -->
            <Dialog ref="editDialog" @submitForm="editSure" @closeDialog="closeEdit" :dialogTitle="'编辑昵称'" :dialogVisible="editShow" :dialogModel="editDialogModel" dialogWidth="700px"></Dialog>
          </div>
        </div>
      </div>
    </div>

    <!-- 管理员导入时候的弹框 -->
    <el-dialog class="duty-excel-dialog" title="批量导入" :visible.sync="importDialog" :width="supportsDutyExcelV2 ? '70%' : '30%'" :close-on-click-modal="false" @close="importClose">
      <div class="importService">
        <div class="firstStep">
          <p class="first">
            第一步：填写数据到
            <!-- <a href="#" download=""  title="下载" class="template" >Excel模板</a> -->
            <span style="color: #409eff; cursor: pointer" @click="downloadTemplate">Excel模板</span>
            中，上传说明：
          </p>
          <p class="indent" v-if="supportsDutyExcelV2">a、表头填写客服昵称、客服昵称改动点及需要调整的日期；未列出的日期保留原排班。</p>
          <p class="indent" v-else>a、请使用当前环境导出的旧版模板；空日期格仍按旧版导入规则处理。</p>
          <p class="indent">b、客服昵称项默认由系统自动获取；</p>
          <p class="indent">c、日期项中可以输入对应客服人员的真实名称；</p>
          <p class="indent" v-if="supportsDutyExcelV2">d、改动点填写删除或新昵称，日期留空不修改原排班。</p>
        </div>
        <div class="secondStep">
          <p class="second">第二步：</p>
          <div class="indent importBrn">
            <div>上传Excel文件</div>
            <div>
              <el-upload ref="dutyExcelUpload" class="upload-demo" action="" :before-upload="handleFileProgress" :limit="1" :multiple="false">
                <el-button size="small" type="primary">点击上传文件</el-button>
                <div slot="tip" class="el-upload__tip" style="color: #409eff" v-show="!!fileName">{{ '当前选择的文件：' + fileName }}</div>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div v-if="supportsDutyExcelV2 && importPreview" class="duty-import-preview">
        <div class="duty-import-summary">新增 {{ importPreview.created }} · 改名 {{ importPreview.renamed }} · 删除 {{ importPreview.deleted }} · 删除未来未确认排班 {{ importPreview.deleted_duties }} · 排班更新 {{ importPreview.duties }}</div>
        <el-table :data="importPreview.actions" size="mini" border max-height="220" style="width: 100%">
          <el-table-column prop="row" label="Excel行" width="85"></el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">{{ dutyActionName(scope.row.action) }}</template>
          </el-table-column>
          <el-table-column prop="old" label="原昵称" min-width="130"></el-table-column>
          <el-table-column prop="name" label="导入后昵称" min-width="130"></el-table-column>
        </el-table>
        <div class="duty-import-order">导入后顺序：{{ importPreview.order.join('、') }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="importLoading" @click="importDialog = false">取 消</el-button>
        <el-button type="primary" :loading="importLoading" @click="sureImportFile">{{ supportsDutyExcelV2 ? (importPreview ? '确认导入' : '预览') : '确 定' }}</el-button>
      </span>
    </el-dialog>

    <!-- 下载模板的时候选择对应的时间框 -->
    <el-dialog title="选择模板时间" :visible.sync="chooseTimeDialogVisible" width="300px" :modal="false" @close="selectTimeClose">
      <div class="chooseTime">
        <el-date-picker v-model="selectTime" type="month" placeholder="请选择日期" format="yyyy-MM" value-format="yyyy-MM"> </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureDownload">确定下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog';
import FilterCommon from '@/components/common/Filter';
import { getDutyList, saveDutyData, deleteDutyNickname, addDutyNickname, importExcel, serviceSure, editDutyNickname } from '@/api/vipQualityTest';
import BASE_API from '@/config';
import clipboard from '@/utils/clipboard';
import * as XLSX from 'xlsx';
import { isLegacyDutyExcelHeader } from '@/utils/dutyExcel';

export default {
  name: 'dutyList',
  components: { FilterCommon, Dialog },
  data() {
    return {
      listLoading: false,
      tableData: [],
      timeArr: [],
      currentTime: '',
      saveArr: {},
      delShow: false,
      searchObj: {},
      model: [],
      dialogVisible: false,
      dialogModel: [
        {
          type: 'el-input',
          label: '昵称',
          prop: 'nickname',
        },
      ],
      editDialogModel: [
        {
          type: 'el-input',
          label: '旧昵称',
          prop: 'nickname_old',
          isDisabled: true,
        },
        {
          type: 'el-input',
          label: '新昵称',
          prop: 'nickname_new',
        },
      ],
      importDialog: false,
      fileName: '',
      uploadFile: {},
      importPreview: null,
      importLoading: false,
      supportsDutyExcelV2: false,
      isSuperAdmin: false, // 是否是超级管理员
      isShowEnSure: false, // 确认按钮的展示
      isShowChange: false, // 管理员切换按钮的展示
      changeStatus: 0, // 1、排班页面  0、确认页面
      downloadFileUrl: BASE_API + 'admin/get_duty_excel', //下载模板地址
      exportFileUrl: BASE_API + 'admin/get_duty_excel_data', // 导出地址
      chooseTimeDialogVisible: false, // 模板时间
      selectTime: '', // 模板时间
      editShow: false, // 编辑弹窗显示
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.listLoading = true;
      const { data } = await getDutyList(this.searchObj);
      console.log(data);
      if (data.code === 200) {
        this.model = [
          {
            span: 5,
            type: 'date-picker',
            label: '时间',
            key: 'duty_at',
            dateType: true,
            empty: false,
            pick: true,
          },
        ];
        if (data.data.show_status_option) {
          this.model.push({
            span: 5,
            type: 'select',
            label: '状态',
            key: 'ensure_status',
            clearable: true,
            placeholder: '请选择确认状态',
            options: [
              { value: 0, name: '未确认' },
              { value: 1, name: '已确认' },
            ],
          });
        }
        const timeArr = data.data.time_array;
        this.currentTime = timeArr.pop();
        this.timeArr = timeArr;
        this.tableData = data.data.data;
        this.supportsDutyExcelV2 = !!data.data.duty_excel_v2;
        // 超级管理员的删除列按钮
        this.delShow = data.data.is_super_admin;
        // 是否是超级管理员 展示添加
        this.isSuperAdmin = data.data.is_super_admin;
        // 普通客服的是否展示确认按钮
        this.isShowEnSure = data.data.show_ensure_button;
        // 新增管理员切换按钮的展示
        this.isShowChange = data.data.show_switch_button;
        data.data.data.forEach((m) => {
          this.$set(this.saveArr, m.nickname, m[this.currentTime]);
        });
        this.listLoading = false;
      } else {
        this.$message.error(data.message);
        this.listLoading = false;
      }
    },
    async save() {
      const val = [];
      for (let key in this.saveArr) {
        if (this.saveArr[key] != '') {
          val.push({ nickname: key, staff_name: this.saveArr[key] });
        }
      }
      const obj = { data: val, duty_at: this.currentTime };
      const { data } = await saveDutyData(obj);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('保存成功');
      this.getList();
    },
    async del(row) {
      const { data } = await deleteDutyNickname({ nickname: row.nickname });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('删除成功');
      this.getList();
    },
    // 点击编辑
    edit(row) {
      this.editShow = true;
      this.$refs.editDialog.resetForm();
      this.$refs.editDialog.editForm({ nickname_old: row.nickname });
    },
    // 确定编辑
    async editSure(form) {
      const { data } = await editDutyNickname(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('修改成功');
      this.closeEdit();
      this.getList();
    },
    // 关闭编辑
    closeEdit() {
      this.editShow = false;
      this.$refs.editDialog.resetForm();
    },
    add() {
      this.dialogVisible = true;
    },
    async dialogSure(form) {
      const { data } = await addDutyNickname(form);
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('添加成功');
      this.closeDialog();
      this.getList();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    search(data) {
      this.searchObj = { duty_at: data.duty_at, ensure_status: data.ensure_status, duty_switch: this.changeStatus };
      this.getList();
    },
    reset() {
      this.searchObj = {};
    },
    // 导出
    exportService() {
      window.open(this.exportFileUrl, '_blank');
    },
    // 超级管理员导入客服
    importService() {
      this.importDialog = true;
    },
    handleFileProgress(file) {
      this.fileName = file.name;
      this.uploadFile = file;
      this.importPreview = null;
      return false;
    },
    // 导入弹框关闭
    importClose() {
      this.fileName = '';
      this.uploadFile = '';
      this.importPreview = null;
      this.importDialog = false;
      if (this.$refs.dutyExcelUpload) {
        this.$refs.dutyExcelUpload.clearFiles();
      }
    },
    // 确认导入数据
    async sureImportFile() {
      if (!this.uploadFile || !this.uploadFile.name) {
        this.$message.error('请先选择Excel文件');
        return;
      }
      this.importLoading = true;
      try {
        if (!this.supportsDutyExcelV2 && !(await this.hasLegacyDutyExcelHeader(this.uploadFile))) {
          this.$message.error('当前服务端尚不支持新版排班Excel，请使用当前环境导出的模板');
          return;
        }
        const formdata = new FormData();
        formdata.append('file', this.uploadFile);
        if (this.supportsDutyExcelV2) {
          formdata.append('mode', this.importPreview ? 'apply' : 'preview');
          if (this.importPreview) {
            formdata.append('preview_token', this.importPreview.token);
          }
        }
        const { data: res } = await importExcel(formdata);
        if (res.code !== 200) {
          this.$message.error(res.message || '导入失败');
          this.importPreview = null;
          return;
        }
        if (this.supportsDutyExcelV2 && !this.importPreview) {
          this.importPreview = res.data;
          return;
        }
        if (this.supportsDutyExcelV2 && res.data.inspection_status === 'failed') {
          this.$message.warning('排班已写入，历史质检同步失败，请联系管理员');
        } else if (this.supportsDutyExcelV2 && res.data.inspection_status === 'queued') {
          this.$message.success('排班已写入，历史质检同步中');
        } else {
          this.$message.success('导入成功');
        }
        this.importDialog = false;
        this.getList();
      } catch (error) {
        this.$message.error('Excel文件无法读取或导入失败');
      } finally {
        this.importLoading = false;
      }
    },
    // 旧服务端会把改动点列当日期，不能接收新版文件。
    hasLegacyDutyExcelHeader(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = () => {
          try {
            const workbook = XLSX.read(new Uint8Array(reader.result), { type: 'array', sheetRows: 1 });
            const rows = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: 1 });
            resolve(isLegacyDutyExcelHeader(rows[0]));
          } catch (error) {
            reject(error);
          }
        };
        reader.readAsArrayBuffer(file);
      });
    },
    dutyActionName(action) {
      return { keep: '保留', add: '新增', rename: '改名', delete: '删除' }[action] || action;
    },

    // 非超管人员确认排班
    async sureThisList() {
      if (this.tableData.length > 0) {
        let nickname_array = [];
        let duty_at;
        for (let item in this.tableData[0]) {
          if (item.split('-').length === 3) {
            duty_at = item;
          }
        }
        this.tableData.forEach((item) => {
          if (item.ensure_status === 0) {
            nickname_array.push(item.nickname);
          }
        });
        const params = {
          nickname_array,
          duty_at,
        };
        const { data: res } = await serviceSure(params);
        if (res.code === 200) {
          this.$message.success('确认成功');
          this.getList();
        }
      }
    },
    // 导入时候下载模板
    downloadTemplate() {
      // console.log(111)
      this.chooseTimeDialogVisible = true;
    },
    sureDownload() {
      if (this.selectTime === '') {
        return this.$message.error('请先选择时间');
      } else {
        let a = document.createElement('a');
        a.href = `${this.downloadFileUrl}?year_month=${this.selectTime}`;

        a.click();
        this.selectTimeClose();
      }
    },
    selectTimeClose() {
      this.chooseTimeDialogVisible = false;
      this.selectTime = '';
    },

    // 复制当前页指定列的内容
    copyColumn(prop, event) {
      if (!this.tableData.length) {
        this.$message.warning('暂无可复制数据');
        return;
      }
      const text = this.tableData
        .map((row) => {
          if (prop === this.currentTime) {
            const value = this.saveArr[row.nickname];
            return value === undefined || value === null ? '' : value;
          }
          const value = row[prop];
          return value === undefined || value === null ? '' : value;
        })
        .join('\n');
      clipboard(text, event);
    },

    // 新增的管理员切换显示状态
    changeShowPage() {
      document.getElementById('reset').click();
      this.changeStatus = this.changeStatus === 0 ? 1 : 0;
      this.searchObj = { duty_switch: this.changeStatus };
      this.getList();
    },
  },
};
</script>

<style lang="less">
.importService {
  font-size: 16px;
  margin-left: 30px;
  line-height: 20px;
  .template {
    color: #409eff;
    cursor: pointer;
  }
  .first {
    margin-bottom: 10px;
  }
  .indent {
    text-indent: 30px;
  }
  .second {
    margin: 10px;
    margin-left: 0;
  }
  .importBrn {
    display: flex;
    .el-button {
      margin-top: 0;
    }
    .el-upload--text {
      width: inherit;
      height: inherit;
      border: none;
    }
  }
}

.duty-excel-dialog {
  .duty-import-preview {
    margin-top: 16px;
  }
  .duty-import-summary {
    margin-bottom: 10px;
    line-height: 22px;
  }
  .duty-import-order {
    max-height: 100px;
    margin-top: 10px;
    overflow: auto;
    line-height: 22px;
    word-break: break-all;
  }
}

@media (max-width: 700px) {
  .duty-excel-dialog .el-dialog {
    width: calc(100% - 24px) !important;
  }
}

.fontred {
  .el-input__inner {
    color: red;
  }
}

.fontgreen {
  .el-input__inner {
    color: green;
  }
}

.copy-column-icon {
  margin-left: 6px;
  color: #409eff;
  cursor: pointer;
}
</style>
